export const properties = {
    ARIA_LABEL_ARTICLE: 'Pregunta' 

}